import block from '../components/shared/Product/assets/block.png';
import { buildSelAndCutLoopStrings } from './PatternHelper';

// Extract RGB color from specifier like "COLOR(RGB(180,170,151))" or "RGB(180,170,151)"
const extractRgbColor = (specifier) => {
    if (!specifier) return null;
    const match = specifier.match(/RGB\((\d+),(\d+),(\d+)\)/i);
    if (match) {
        return `rgb(${match[1]}, ${match[2]}, ${match[3]})`;
    }
    return null;
};

// Generate thumbnail URL
const getThumbnailUrl = (product, size = 1024, focus = 1024) => {
    if (!product) return null;

    const defaultRoomSceneSpecifier = product.defaultRoomSceneSpecifier;

    if (product.specifier?.indexOf('RGB') !== -1) {
        return `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(${product.specifier})&type=prod&extra=(focus=${focus})&Size=${size}`;
    }

    if (product.seriesID != 9727) {
        return `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}`;
    }

    let output = buildSelAndCutLoopStrings(product);

    return `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${product.specifier}(APPLY=(SCALE=1,COLORS=(${output.selString}),TEXTURES=(${output.cutLoopString})),FOCUS=(@SIZE[1]/(@PATRES[1]|@RES[1])))&size=248&extra=(SIZE=(?,(@SIZE[1]*@PATRES[2]/@PATRES[1])))`;
};

// Generate thumbnail image element - handles RGB colors automatically
const ProductThumbnail = ({ product, size = 256, alt = '', className = '', style = {}, ...props }) => {
    if (!product) return null;

    const isRgbProduct = product.specifier?.indexOf('RGB') !== -1;
    const rgbColor = isRgbProduct ? extractRgbColor(product.specifier) : null;

    if (isRgbProduct && rgbColor) {
        return (
            <img
                src={block}
                alt={alt}
                className={className}
                style={{ backgroundColor: rgbColor, ...style }}
                {...props}
            />
        );
    }

    return (
        <img
            loading="lazy"
            src={getThumbnailUrl(product, size)}
            alt={alt}
            className={className}
            style={style}
            {...props}
        />
    );
};

export { getThumbnailUrl, ProductThumbnail, extractRgbColor };
